<template>
  <v-menu
    v-model="menuActive"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="formatDate"
        readonly
        rounded
        filled
        :disabled="disabled"
        :class="inputClass"
        v-bind="$attrs"
        v-on="on"
      >
        <template v-slot:append>
          <v-icon v-if="!disabled">
            mdi-calendar-blank-outline
          </v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      :type="type"
      :max="isoFormat(max)"
      :min="isoFormat(min)"
      :value="isoFormat(value)"
      :header-date-format="headerFormat"
      :year-format="yearFormat"
      @input="$emit('input', $event)"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'BaseDatePicker',
  inheritAttrs: false,
  props: {
    value: {
      type: [Date, String],
      default: ''
    },
    formatTemplate: {
      type: String,
      default: 'DD MMM YYYY'
    },
    min: {
      type: [Date, String],
      default: undefined
    },
    max: {
      type: [Date, String],
      default: undefined
    },
    type: {
      type: String,
      default: undefined
    },
    inputClass: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {
      menuActive: false
    }
  },
  computed: {
    formatDate() {
      if (this.value) {
        if (this.type === 'month') {
          return this.$utils
            .createDayjsDate(this.value)
            .locale('th')
            .format(this.formatTemplate)
        }
        return this.$utils
          .createDayjsDate(this.value)
          .locale('th')
          .format(this.formatTemplate)
      }

      return undefined
    }
  },
  methods: {
    isoFormat(value) {
      if (value) {
        if (this.type === 'month') {
          return this.$utils.createDayjsDate(value).format('YYYY-MM')
        }

        return this.$utils.createDayjsDate(value).format('YYYY-MM-DD')
      }

      return undefined
    },
    headerFormat(date) {
      return this.$utils.createDayjsDate(date)
        .locale('th')
        .format('MMMM YYYY')
    },
    yearFormat(date) {
      return `ค.ศ. ${this.$utils.createDayjsDate(date).locale('th').format('YYYY')}`
    }
  }
}
</script>

<style>
._error--text input {
  color: #ef2956 !important;
  caret-color: #ef2956 !important;
}
._green--text input {
  color: #01bb00 !important;
  caret-color: #01bb00 !important;
}
</style>
